import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import Logo from '../../icons/Logo';

const Masthead = styled.header`
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  justify-content: space-between;
  border-bottom: 1px solid #e4e4e4;
  background-color: #ffffff;
`;

const LogoLinkWrapper = styled.a`
  padding-top: 8px;
  padding-bottom: 4px;
  padding-left: 0.75rem;
  align-items: center;
`;

const ActionItems = styled.div`
  display: flex;
  flex-direction: row;
`;

interface Props {
  children?: ReactNode;
}

export const Header = (props: Props) => {
  return (
    <Masthead>
      <LogoLinkWrapper href="/">
        <Logo preserveAspectRatio="xMinYMin" />
      </LogoLinkWrapper>
      <ActionItems>{props.children}</ActionItems>
    </Masthead>
  );
};

export default Header;
